// extracted by mini-css-extract-plugin
export default {"wrap":"announcementView_wrap__F1cdS","container":"announcementView_container__BQl54","syncButton":"announcementView_syncButton__yN1dT"};